import {Swiper} from 'swiper'
import {breakpointDown} from "../helpers/breakpoints";
import { ScrollTrigger } from 'gsap/ScrollTrigger'


//---- Slider for buttons or other elements in one row in phones. 
//--       slides riht and back when scrolled in screen
//--
//-- <div class="swiper js-responsive-buttons-swiper">
//--    <div class="swiper-wrapper">
//--        <div class="swiper-slide">

$('.js-responsive-buttons-swiper').each((i, el)=> {

  if (breakpointDown('xl')) {


    // animate  when in screen
    let swiperLastEl = $(el).find('.swiper-slide').last()
    if (swiperLastEl.offset().left + swiperLastEl.width() > window.innerWidth - 20) {

      let swiper = new Swiper(el, {
        slidesPerView: 'auto',
      });

      ScrollTrigger.create({
        trigger: el,
        start: "top bottom", // el top, screen bottom
        once: true,
        onEnter: () => {
          $(el).find('.swiper-wrapper').delay(400).animate({ left: '-80px' }, 600,
            function () {
              $(this).animate({ left: 0 }, 600)
            })
        }
      });

    }

  }

})

